// extracted by mini-css-extract-plugin
export var button = "_dg-0";
export var icon = "_dg-1";